/* eslint-disable */
const mutations = {
  toggleSidebar(state, isOpen) {
    state.isOpen = isOpen;
  },
};

export default mutations;
